<script>
import DefaultSwagbagFileForm from "@/views/menu/event/defaultSwagbagFile/defaultSwagbagFileForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    defaultSwagbagFileService: "defaultSwagbagFileService",
    eventService: "eventService",
    fileUploadService: "fileUploadService",
    visitorLevelService: "visitorLevelService",
    toastService: "toastService",
  }
})
export default class DefaultSwagbagFileEdit extends mixins(DefaultSwagbagFileForm) {
  formId = "edit-defaultSwagbagFile-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        disabled: () => {
          return this.fileUploadService.isUploading();
        },
        handle: this.save
      }
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
      let defaultSwagbagFile = {
        idEvent: this.$route.params.idEvent,
        idLanguage: this.model.idLanguage,
        idCategory: this.model.idCategory,
        name: this.model.name,
        description: this.model.description,
        uri: this.model.uri,
        assignmentPolicy: this.model.assignmentPolicy,
        users: this.model.users,
        visitorLevels: this.model.visitorLevels
      };
        await this.defaultSwagbagFileService.update(this.$route.params.id, defaultSwagbagFile);
      this.$router.push(`/swagbag/list/${this.$route.params.idEvent}`);
      this.toastService.success(this.translations.success.defaultSwagbagFile_update);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle () {
    return this.translations.pageTitles.defaultSwagbagFile_edit;
  }

  async created() {
    this.setVisitorLevels(await this.visitorLevelService.enabledLevels(this.$route.params.idEvent));
    this.model = await this.defaultSwagbagFileService.read(this.$route.params.id);
    this.selectedUsers = await this.defaultSwagbagFileService.listAssignedUsers(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
